export default {
  title: 'Setări',
  fields: {
    discount_type: {
      label: 'Tip reducere',
    },
  },
  buttons: {
    save: 'Salvează',
    cancel: 'Anulează',
  },
  toasts: {
    update_successful: 'Actualizat cu succes',
    updated_failed: 'Actualizare eșuată',
  },
};
